export const getStore = state => state.monitoredDocumentVersions || {};

export const getMonitoredDocumentVersions = state =>
    getStore(state).monitoredDocumentVersions || [];
export const getPaging = state => getStore(state).paging;

export const isFetching = state => getStore(state).fetching;
export const isFetched = state => getStore(state).fetched;
export const hasFailed = state => getStore(state).failed;
